<template>
	<v-row justify="center">
		<v-dialog v-model="ui.dialog" persistent max-width="600">
			<v-card class="pa-4" v-if="articlePriceList">
				<v-card-title>
					Editar articulo de lista de precio
				</v-card-title>
				<v-card-subtitle>
					{{
						`${articlePriceList.code} - ${articlePriceList.description}`
					}}
				</v-card-subtitle>
				<v-card-text class="pb-0">
					<v-form
						ref="form"
						v-model="ui.valid"
						lazy-validation
						@submit.prevent="update()"
					>
						<v-row>
							<v-col cols="12" md="6" class="pb-0">
								<v-text-field
									dense
									outlined
									label="Precio preferente"
									autocomplete="off"
									v-model="
										articlePriceList.pivot
											.preferential_price
									"
									:rules="[
										v.required,
										v.min(
											'numeric',
											1,
											articlePriceList.pivot
												.preferential_price
										),
									]"
									@keyup.enter="update()"
								></v-text-field>
							</v-col>
							<v-col cols="12" md="6" class="pb-0">
								<v-text-field
									dense
									outlined
									label="Descuento(%)"
									autocomplete="off"
									v-model="
										articlePriceList.pivot
											.preferential_discount
									"
									:rules="[
										v.required,
										v.min(
											'numeric',
											0,
											articlePriceList.pivot
												.preferential_discount
										),
										v.max(
											'numeric',
											100,
											articlePriceList.pivot
												.preferential_discount
										),
									]"
									@keyup.enter="update()"
								></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions class="d-flex justify-end">
					<v-btn
						color="primary"
						text
						@click="ui.dialog = false"
						:disabled="ui.storing"
					>
						cancelar
					</v-btn>
					<v-btn
						color="primary"
						@click="update()"
						:loading="ui.storing"
						:disabled="!ui.valid"
					>
						enviar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import axios from "axios";
import { V } from "@/main";
import { EventBus } from "@/main";
import { mapState } from "vuex";

export default {
	name: "ArticlePriceListEdit",

	data() {
		return {
			articlePriceList: null,

			v: V,

			ui: {
				valid: true,
				dialog: false,
				storing: false,
			},
		};
	},

	created() {
		EventBus.$on("ArticlePriceListEdit", (articlePriceList) => {
			this.articlePriceList = {
				...articlePriceList,
				pivot: {
					...articlePriceList.pivot,
				},
			};

			this.ui.dialog = true;
		});
	},

	methods: {
		async update() {
			try {
				if (this.$refs.form.validate()) {
					this.ui.storing = true;

					let response = await axios.put(
						`${process.env.VUE_APP_API_SERVER}/auth/pricelist/${this.$route.params.id}/articlepricelist`,
						{
							article_price_list: [
								{
									...this.articlePriceList.pivot,
								},
							],
						},
						{
							headers: {
								Authorization: `Bearer ${this.acount.token}`,
							},
						}
					);

					EventBus.$emit(
						"ArticlePriceListUpdated",
						response.data.data
					);

					this.ui.dialog = false;
				}
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.storing = false;
			}
		},
	},

	computed: {
		...mapState(["acount"]),
	},
};
</script>

<style lang="css" scoped></style>
